import { render, staticRenderFns } from "./PhoneNumberField.vue?vue&type=template&id=5b44f41c&"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports